import SectionHead from "@/components/SectionHead";
import { CheckCircle2 } from "lucide-react";
import { useLang } from "@/i18n";

const WhoNeeds = () => {
  const t = useLang().t;
  return (
  <section data-testid="who-needs" className="bg-[#FDFBF7] py-16 sm:py-24">
    <div className="container-site">
      <SectionHead
        testId="who-needs-head"
        eyebrow={t.who.eyebrow}
        title={t.who.title}
        sub={t.who.sub}
      />
      <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {t.who.cards.map((b, i) => (
          <div
            key={b.name}
            data-testid={`who-card-${i}`}
            className="flex items-start gap-3 rounded-2xl border border-[#EFEBE4] bg-white p-5 transition-shadow duration-200 hover:shadow-md"
          >
            <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-[#A88667]" />
            <div>
              <p className="font-heading text-base font-bold text-[#3E2723]">{b.name}</p>
              <p className="mt-1 text-sm text-[#5D4037]">{b.benefit}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
  );
};

export default WhoNeeds;
